export default [
  { to: 'innehall', title: 'Innehåll' },
  { to: 'tolkning', title: 'Tolkning' },
  { to: 'ekg-exempel', title: 'EKG-exempel' },
  { to: 'hjartinfarkt-och-lungemboli', title: 'Hjärtinfarkt och lungemboli' },
  { to: 'forsta-gangen', title: 'Första gången appen används' },
  { to: 'quiz', title: 'Quiz' },
];
